import * as React from 'react';
import { useTeamsContext } from '../../teams-tabs/teams-context/TeamsContext';
import { SessionContextProvider } from './SessionContext';
import { ISessionContextProviderProps } from './SessionContext.types';

export const ConnectedSessionContextProvider: React.FC<
  ISessionContextProviderProps
> = props => {
  const { teamsContext } = useTeamsContext();

  return <SessionContextProvider {...props} teamsContext={teamsContext} />;
};
